import orderAxiosInstance from './api';
import {
    BatchReturnProcessingSummary,
    BatchReturnProcessingResult,
    BatchPackageReturnSlipResult,
    BatchCloseRemainingResult,
    BatchCreditResult,
} from 'types/batchReturnProcessing';

export const batchReturnProcessingService = {
    getProcessingSummary: async (batchReturnId: number): Promise<BatchReturnProcessingSummary> => {
        const response = await orderAxiosInstance.get<BatchReturnProcessingSummary>(
            `/api/return/batch/${batchReturnId}/processing`,
        );
        return response.data;
    },

    processReturns: async (batchReturnId: number, returnIds: number[]): Promise<BatchReturnProcessingResult> => {
        const response = await orderAxiosInstance.post<BatchReturnProcessingResult>(
            `/api/return/batch/${batchReturnId}/processing`,
            { returnIds },
        );
        return response.data;
    },

    createReturnSlipForPackage: async (
        batchReturnId: number,
        sourceReturnId: number,
    ): Promise<BatchPackageReturnSlipResult> => {
        const response = await orderAxiosInstance.post<BatchPackageReturnSlipResult>(
            `/api/return/batch/${batchReturnId}/packages/${sourceReturnId}/returnslip`,
        );
        return response.data;
    },

    markPackageMissing: async (batchReturnId: number, sourceReturnId: number): Promise<void> => {
        await orderAxiosInstance.post(`/api/return/batch/${batchReturnId}/packages/${sourceReturnId}/missing`);
    },

    unmarkPackageMissing: async (batchReturnId: number, sourceReturnId: number): Promise<void> => {
        await orderAxiosInstance.delete(`/api/return/batch/${batchReturnId}/packages/${sourceReturnId}/missing`);
    },

    creditReturnSlips: async (batchReturnId: number, returnSlipIds: number[]): Promise<BatchCreditResult> => {
        const response = await orderAxiosInstance.post<BatchCreditResult>(`/api/return/batch/${batchReturnId}/credit`, {
            returnSlipIds,
        });
        return response.data;
    },

    completeBatch: async (batchReturnId: number): Promise<void> => {
        await orderAxiosInstance.post(`/api/return/batch/${batchReturnId}/complete`);
    },

    reopenBatch: async (batchReturnId: number, comment: string, sourceReturnId?: number): Promise<void> => {
        await orderAxiosInstance.post(`/api/return/batch/${batchReturnId}/reopen`, { comment, sourceReturnId });
    },

    closeRemainingAsMissing: async (batchReturnId: number): Promise<BatchCloseRemainingResult> => {
        const response = await orderAxiosInstance.post<BatchCloseRemainingResult>(
            `/api/return/batch/${batchReturnId}/close-remaining`,
        );
        return response.data;
    },
};
